import React, { useState, useEffect } from 'react';
import omit from 'lodash/omit';
import { loadInitialData } from './utils';

const ResourceWrapper = (WrappedComponent) => {
  const InnerComponent = (props) => {
    const {
      globals,
      isAssign,
      formData,
      allSections,
      subject: { id: subjectId },
      videoResource: { unit: { unitId: unitIdForAssign } = {} } = {},
      isPreApSubject,
      openAssignments,
      selectedAssignment,
      onAssignmentSelect,
      item,
      assignmentId,
      initialized: wasFormInitialized,
      isStudentsFormChanged,
      handleShowClassSwitchingInfoModal,
      isAdminOrCoordinator,
      onResourceDeselect,
    } = props;
    const {
      url,
      unitId: unitIdForManageSettings,
      providerVideoId,
    } = item || {};
    const videoUnitId = unitIdForAssign || unitIdForManageSettings;
    const videoId = url || providerVideoId;
    const {
      isLoading: isGlobalLoading,
      initForm,
      setCanSubmit: setGlobalCanSubmit,
      submit: globalSubmit,
      hasUpdatedOptions,
    } = globals;
    const {
      startsAt,
      dueAt,
      title,
      students: formStudents,
      allAssignees,
    } = formData;
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
      if (isAdminOrCoordinator) {
        setIsLoading(false);
      } else {
        loadInitialData({ ...props }, { setIsLoading });
      }
    }, []);

    // Keep this `useEffect` to trigger re-render of child components.
    // This is used for switching between assignments.
    useEffect(() => {
      if (!isGlobalLoading && isLoading) {
        setIsLoading(false);
      }
    }, [isLoading]);

    useEffect(() => {
      if (!isLoading) {
        initForm({
          ...globals,
          allSections,
          selectedAssignment,
        });
      }
    }, [isLoading, selectedAssignment]);

    useEffect(() => {
      if (isLoading || isGlobalLoading || !wasFormInitialized) return;
      const hasAssignees = allAssignees.length > 0 || formStudents.length > 0;
      const enableSubmitBtn = isAssign
        ? hasAssignees > 0 && hasUpdatedOptions()
        : hasUpdatedOptions();

      setGlobalCanSubmit(enableSubmitBtn);
    }, [
      isLoading,
      wasFormInitialized,
      startsAt,
      dueAt,
      title,
      formStudents,
      assignmentId,
    ]);

    const submit = async () => {
      await globalSubmit();
    };

    const setSelectedAssignment = (newSelectedAssignment) => {
      setIsLoading(true);

      isStudentsFormChanged &&
        handleShowClassSwitchingInfoModal &&
        handleShowClassSwitchingInfoModal(true);

      onAssignmentSelect(newSelectedAssignment);
    };

    const shareLinkData = {
      header: 'Share Video',
      link: `${FYM_FRONTEND_URL}/d/${videoId}?sui=${subjectId},${videoUnitId}`,
      ctaText: 'Copy',
      timeout: 3,
    };

    const resourceProps = {
      showRenameDropdown: !isPreApSubject,
      showFormatOption: false,
      showLdbOption: false,
      showScrambleQuestionsOption: false,
      section: null,
      submit,
      // withAdvancedSettings: isAssign,
      withAdvancedSettings: false,
      showTimeSettings: true,
      showTimerOptions: false,
      showTimer: false,
      showStartDateResetButton: false,
      shareLinkData,
      openAssignments,
      selectedAssignment,
      setSelectedAssignment,
      onResourceDeselect,
    };

    return (
      <WrappedComponent
        isLoading={isGlobalLoading || isLoading}
        {...omit(props, ['isLoading', 'globals'])}
        {...resourceProps}
      />
    );
  };

  return InnerComponent;
};

ResourceWrapper.displayName = 'ResourceWrapper';

export default ResourceWrapper;
